import { isEmpty, find } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import Selector from '../../Common/Selector';
import { IAvatar } from '@components/CRM/Clients/Avatar';
import { ValueOf } from '@utils/tsUtils';
import { OperatorStates } from '@components/OperatorStatusSelector';
import { MailGroupType } from 'types/types';

const { CLASS_NAME_PREFIX } = Selector;

const PLACEHOLDER = 'Выберите группу';

const StyledFilter = styled(Selector)`
  border: 1px solid #e6e9ee;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 3px;

  .${CLASS_NAME_PREFIX}__multi-value {
    background: #f5f3f2;
    border: none;
  }

  .${CLASS_NAME_PREFIX}__multi-value__label {
    padding: 0 0 0 10px;
  }

  .${CLASS_NAME_PREFIX}__placeholder {
    color: #4d4d4d;
  }
`;

// TODO: вынестти в глобальные типы
type CurrentManagerType = {
  activeTicketsCount: number;
  avatarUrl: IAvatar['url'];
  id: string;
  isOperator: boolean;
  isSupervisor: boolean;
  name: string;
  number: string;
  operatorState: ValueOf<typeof OperatorStates>;
  reservedTicketsCount: number;
  sessionId: string;
  skillGroupIds: number[];
};

interface TicketFilterByMailGroupProps {
  className?: string;
  name: string;
  mailGroups: MailGroupType[] | null;
  value: string[] | null;
  onChange: (event: CustomEvent) => void;
  currentManager: CurrentManagerType;
}

class TicketFilterByMailGroup extends React.PureComponent<TicketFilterByMailGroupProps> {
  el: any = null;

  static defaultProps = {
    className: '',
    name: '',
    mailGroups: null,
    value: null,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleRef = this.handleRef.bind(this);
  }

  handleChange(value) {
    const { name, onChange } = this.props;

    const formatedValue = Array.isArray(value) ? value.map(v => v.value) : null;
    this.el.name = name;
    this.el.value = formatedValue;

    const event = new CustomEvent('change', { bubbles: true });

    this.el.dispatchEvent(event);
    onChange(event);
  }

  handleRef(ref) {
    this.el = ReactDOM.findDOMNode(ref);
  }

  render() {
    const { mailGroups, value, currentManager, ...props } = this.props;

    if (isEmpty(mailGroups)) {
      return null;
    }

    let formatedValue: (MailGroupType | undefined)[] | null = null;
    if (Array.isArray(value)) {
      formatedValue = value.map(v => find(mailGroups, { value: v }));
    }

    // сортируем группы по скилл-группам менеджера
    const sortedMailGroups = mailGroups
      ?.sort((a, b) => {
        const indexA = currentManager.skillGroupIds.indexOf(
          a.skillGroupId ?? -1
        );
        const indexB = currentManager.skillGroupIds.indexOf(
          b.skillGroupId ?? -1
        );

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;

        return 0;
      })
      .map(mailGroup => ({
        label: mailGroup.label,
        value: mailGroup.value,
        isHighlighted: currentManager.skillGroupIds.includes(
          mailGroup.skillGroupId ?? -1
        ),
      }));

    return (
      <StyledFilter
        {...props}
        isMulti
        isSearchable
        onChange={this.handleChange}
        options={sortedMailGroups}
        placeholder={PLACEHOLDER}
        ref={this.handleRef}
        value={formatedValue}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
      />
    );
  }
}

export default TicketFilterByMailGroup;
